<template>
    <div class="pa-3" style="max-width:450px; margin: 0 auto">
        <v-card :loading="loading">
            <v-stepper v-model="currentStep" vertical :non-linear="nonLinear" @change="onSelectStep($event)">
                <template v-for="(s, i) in steps">
                    <v-stepper-step :id="`scroller-${i}`" :complete="s.complete" :step="s.step" :key="`s-${i}`" :editable="nonLinear || s.editable">
                        <small v-if="s.title">{{ s.title }}</small>
                    </v-stepper-step>

                    <v-stepper-content :step="s.step" :key="`c-${i}`">
                        <component
                            v-if="currentStep == s.step"
                            :is="currentComp"
                            :store="store"
                            :stepdef="s"
                            @changed="stepChanged"
                            @valid="validChanged"
                            @loading="setLoading"
                            @back="advanceCurrentStep(-1)"
                            @next="next"
                            @error="stepError"
                            @done="onboardingDone"
                            @message="showSnackbar($event)"
                        ></component>
                    </v-stepper-content>
                </template>
            </v-stepper>
        </v-card>
        <v-overlay :value="loading">
            <v-progress-circular indeterminate size="64" color="red" width="8"></v-progress-circular>
        </v-overlay>
    </div>
</template>

<script>
import { mapMutations } from "vuex"
import welcome from "./steps/common/welcome.vue"
import contact from "./steps/common/contact.vue"
import company from "./steps/common/company.vue"
import startdate from "./steps/common/startdate.vue"
import icma from "./steps/indy/icma.vue"
import emgcy from "./steps/common/emgcy.vue"
import license from "./steps/common/license.vue"
import resident from "./steps/common/resident.vue"
import ssn from "./steps/common/ssn.vue"
import convict from "./steps/common/convict.vue"
import bgcheck from "./steps/common/bgcheck.vue"
import liable from "./steps/common/liable.vue"
import icstatus from "./steps/indy/icstatus.vue"
import wcwaiver from "./steps/indy/wcwaiver.vue"
import drvexp from "./steps/indy/drvexp.vue"
import depauth from "./steps/common/depauth.vue"
import notes from "./steps/common/notes.vue"
import cohelp from "./steps/common/cohelp.vue"
import w9req from "./steps/common/w9req.vue"
import sos from "./steps/indy/sos.vue"
import named from "./steps/common/named.vue"
import done from "./steps/common/done.vue"

export default {
    data() {
        return {
            loading: false,
            currentStep: 1,
            nonLinear: false,
            user: {},
            store: {},
            currentComp: welcome,
            steps: [
                {
                    title: "Welcome Indy",
                    step: 1,
                    editable: false,
                    comp: welcome,
                    complete: true,
                    valid: true
                },
                {
                    title: "Contact Information",
                    step: 2,
                    editable: false,
                    comp: contact,
                    complete: false,
                    valid: false
                },
                {
                    title: "Company Contact Information",
                    step: 3,
                    editable: false,
                    comp: company,
                    complete: false,
                    valid: false
                },
                {
                    title: "Start Date",
                    step: 4,
                    editable: false,
                    comp: startdate,
                    complete: false,
                    valid: false
                },
                {
                    title: "Independent Contractor Master Agreement",
                    step: 5,
                    editable: false,
                    comp: icma,
                    complete: false,
                    valid: false
                },
                {
                    title: "Emergency Contact",
                    step: 6,
                    editable: false,
                    comp: emgcy,
                    complete: false,
                    valid: false
                },
                {
                    title: "Driver's License",
                    step: 7,
                    editable: false,
                    comp: license,
                    complete: false,
                    valid: false
                },
                {
                    title: "Residency Status",
                    step: 8,
                    editable: false,
                    comp: resident,
                    complete: false,
                    valid: false
                },
                {
                    title: "Social Security Card",
                    step: 9,
                    editable: false,
                    comp: ssn,
                    complete: false,
                    valid: false
                },
                {
                    title: "Conviction History",
                    step: 10,
                    editable: false,
                    comp: convict,
                    complete: false,
                    valid: false
                },
                {
                    title: "Background Check",
                    step: 11,
                    editable: false,
                    comp: bgcheck,
                    complete: false,
                    valid: false
                },
                {
                    title: "Liability Insurance",
                    step: 12,
                    editable: false,
                    comp: liable,
                    complete: false,
                    valid: false
                },
                {
                    title: "Independent Contractor Status Certificate",
                    step: 13,
                    editable: false,
                    comp: icstatus,
                    complete: false,
                    valid: false
                },
                {
                    title: "Worker's Compensation Waiver",
                    step: 14,
                    editable: false,
                    comp: wcwaiver,
                    complete: false,
                    valid: false
                },
                {
                    title: "Driver Expectations Agreement",
                    step: 15,
                    editable: false,
                    comp: drvexp,
                    complete: false,
                    valid: false
                },
                {
                    title: "Direct Deposit Authorization",
                    step: 16,
                    editable: false,
                    comp: depauth,
                    complete: false,
                    valid: false
                },
                {
                    title: "Driver Notes",
                    step: 17,
                    editable: false,
                    comp: notes,
                    complete: false,
                    valid: false
                },
                {
                    title: "Your Independent Contractor Company",
                    step: 18,
                    editable: false,
                    comp: cohelp,
                    complete: false,
                    valid: false
                },
                {
                    title: "Form W-9 Request for Taxpayer Identification Number",
                    step: 19,
                    editable: false,
                    comp: w9req,
                    complete: false,
                    valid: false
                },
                {
                    title: "Secretary of State Good Standing Filing Date",
                    step: 20,
                    editable: false,
                    comp: sos,
                    complete: false,
                    valid: false
                },
                {
                    title: "Certificate of Liability Insurance",
                    step: 21,
                    editable: false,
                    comp: named,
                    complete: false,
                    valid: false
                },
                {
                    title: "All Done!",
                    step: 22,
                    editable: false,
                    comp: done,
                    complete: false,
                    valid: false
                }
            ]
        }
    },

    methods: {
        ...mapMutations(["showSnackbar", "closeSnackbar", "setForceOnboarding"]),

        advanceCurrentStep(amount) {
            let vm = this

            this.loading = false
            this.currentStep += amount
            this.currentComp = this.steps[this.currentStep - 1].comp

            if (amount > 0) {
                //
                //  We only advance the step in the database if it is greater than the
                //  highest saved step.
                //
                if (this.currentStep > this.user.person.step) {
                    this.user.person.step += amount

                    this.$db.invokeService("EliteService", "setStep", {user: this.user.person.objectId, step: this.user.person.step, debug: this.$db.isDevelopmentMode()})
                    .then((res) => {
                        if (res.error) {
                            vm.showSnackbar({ text: res.error, timeout: -1 })
                        }
                    })
                    .catch((error) => {
                        vm.showSnackbar({ text: error, timeout: -1 })
                    })
                }
            }

            setTimeout(() => {
                let elem = document.querySelector(`#scroller-${vm.currentStep+1}`)
                if (elem) {
                    window.scrollTo(0, amount > 0 ? (vm.currentStep + 1) * parseInt(window.getComputedStyle(elem, null).getPropertyValue('height')) + 8 : elem.offsetTop)
                }
            })
        },

        getData() {
            const vm = this

            this.loading = true

            Promise.all([
                this.$db.getAllRecords("invites", ["detail"], null, null, null, `phone = '${this.$store.state.user.phoneNumber}'`),
                this.$db.getUserToken()
            ])
            .then((res) => {
                let usertoken = res[1]

                vm.user = vm.$store.state.user
                if (res[0] && res[0].length) {
                    vm.user.person.invite = res[0][0].detail
                }

                vm.store = {
                    vue: vm,
                    person: vm.user.person,
                    invite: vm.user.person.invite,
                    contactName: vm.user.person.invite.attnName,
                    contactPhone: vm.$formatPhone(vm.user.person.invite.attnPhone, 10),
                    contactEmail: vm.user.person.invite.attnMail,
                    userName: vm.user.person.name,
                    userFirst: vm.user.person.first,
                    userLast: vm.user.person.last,
                    userStreet: vm.user.person.street,
                    userUnit: vm.user.person.unit,
                    userCity: vm.user.person.city,
                    userState: vm.user.person.state,
                    userZip: vm.user.person.zip,
                    userPhone: vm.user.person.phone,
                    userEmail: vm.user.person.email.toLowerCase(),
                    userMedia: vm.user.person.media,
                    userSSN: vm.user.person.ssn,
                    userMC: vm.user.person.invite.mc,
                    userToken: usertoken,
                    userId: vm.user.person.objectId,
                    emgcyname: vm.user.person.emgcyname,
                    emgcyphone: vm.user.person.emgcyphon,
                    companyName: vm.user.person.company.name,
                    companyStreet: vm.user.person.company.street,
                    companyUnit: vm.user.person.company.unit,
                    companyCity: vm.user.person.company.city,
                    companyState: vm.user.person.company.state,
                    companyZip: vm.user.person.company.zip,
                    companyPhone: vm.user.person.company.phone,
                    companyEmail: vm.user.person.company.email,
                    availableDate: vm.user.person.availableDate,
                    vehicles: vm.user.person.vehicles,
                    paynotes: vm.user.person.invite.payNotes
                }

                for (let idx = 0; idx < vm.user.person.step; idx += 1) {
                    this.steps[idx].complete = true
                    this.steps[idx].editable = true
                }

                vm.currentStep = Math.min(vm.user.person.step, vm.steps.length)
                vm.currentComp = vm.steps[vm.currentStep-1].comp

                setTimeout(() => {
                    let elem = document.querySelector(`#scroller-${vm.currentStep - 1}`)
                    if (elem) {
                        window.scrollTo(0, (vm.currentStep) * parseInt(window.getComputedStyle(elem, null).getPropertyValue('height')) + 8)
                    }
                })

                if (!vm.user.person.cc) {
                    vm.upgradeCompliance(vm.user.person.objectId)
                }
            })
            .catch(error => {
                vm.showSnackbar({ text: error, timeout: -1 })
            })
            .finally(() => {
                vm.loading = false
            })
        },

        upgradeCompliance(id) {
            console.log(id)
        },

        onSelectStep(e) {
            this.currentStep = e
            this.currentComp = this.steps[this.currentStep - 1].comp
        },

        stepChanged() {
        },

        validChanged(value) {
            this.steps[this.currentStep - 1].valid = value  // Not currently used
        },

        setLoading(value) {
            this.loading = value
        },

        next() {
            this.loading = false
            this.steps[this.currentStep - 1].complete = true
            this.steps[this.currentStep - 1].editable = true
            this.advanceCurrentStep(1)
        },

        stepError(error) {
            this.showSnackbar({ text: error, timeout: -1 })
            this.loading = false
        },

        onboardingDone() {
            const user = this.$store.state.user.person
            user.forceComp = false
            this.setForceOnboarding(false)
        }
    },

    created() {
        this.getData()
    },

    components: {
        welcome: welcome,
        contact: contact,
        company: company,
        startdate: startdate,
        icma: icma,
        emgcy: emgcy,
        license: license,
        resident: resident,
        ssn: ssn,
        convict: convict,
        bgcheck: bgcheck,
        liable: liable,
        icstatus: icstatus,
        wcwaiver: wcwaiver,
        drvexp: drvexp,
        depauth: depauth,
        notes: notes,
        cohelp: cohelp,
        w9req: w9req,
        sos: sos,
        named: named,
        done: done
    }
}
</script>

